// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__ZPgbM","question":"Question_question__2_lBB","description":"Question_description__3BGDr"};